import isEqual from "lodash/isEqual";
import {IntermediatePart} from "../../parts/intermediatePart";
import DesignNavigationItem from "../../../../visComponents/designNavigationItem";

import { Shower } from "../../parts/shower";
import { ShowerTubCombo } from "../../parts/showerTubCombo";
import {getFeatureIsLocked} from "../../../../../misc/helpers";

export default class ShowerInteriorWall extends IntermediatePart {

  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partId = 'shower_interior_wall';
    this.partName = 'Shower Walls';
    this.translateId = "visualizer.bathroom.shower.shower_interior_wall";
    this.homePageTitle = 'Interior Shower Walls';
    this.dbName = "Shower Wall";
    this.isStoneFeature = true;
    this.canUseWizard = true;
    this.partNumber = partNumber;
    this.activeFeatureParts = [];
    this.shadowName = "Interior Wall";
    this.layerPriority = 2;
  }

  load(dbFeature) {
    const parts = dbFeature.metaData && dbFeature.metaData["Parts"];
    if (parts) {
      const partNumber = +dbFeature.metaData["Part"][0];
      return super.load_(dbFeature, new ShowerInteriorWall(false, partNumber),
        true, partNumber === 1 ? 'features' : 'featuresParts');
    } else {
      return super.load_(dbFeature, new ShowerInteriorWall());
    }
  }

  handleClick(ignoreLocked) {
    const parent = this.getParent();
    super.handleClick(ignoreLocked);
    parent.activeFeatureParts = parent.setActiveFeatureParts();
    const shower = parent.getParent();
    if (shower.showerInteriorWallAccent && shower.showerInteriorWallAccent.canBeDisabled
      && !shower.showerInteriorWallAccent.placeholderChanged && !getFeatureIsLocked(this)) {
      shower.showerInteriorWallAccent.disabled = true;
      shower.showerInteriorWallAccent.disabledClick();
    }
    this.featureClicked();
  }

  navigationSubItems(filters, searchText) {
    const filteredAvailableFeatures = super.getFeaturesBySearchText(this.availableFeatures(super.getFilteredFeaturesByFilters(filters)), searchText);
    const featuresToDisplay = super.navigationSubItemsWithFilterMultipleConditions(this.getArrayOfConditions(), filteredAvailableFeatures);
    return featuresToDisplay.map(_ => new DesignNavigationItem(_.featureName, _));
  }

  availableFeatures(wallFeatures) {
    return wallFeatures.filter(wallFeature => wallFeature.partNumber === 1)
  }

  setLayers(layout) {
    if (this.shadowFeature && !this.shadowFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions())) {
      this.setShadowFeature();
    }
    if (this.activeFeature && (this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions())
        || (this.activeFeature.notAvailableInVisualizer && this.placeholderFeature))) {
      this.activeFeatureParts = this.setActiveFeatureParts();
      super.setLayers(layout);
    } else {
      this.setDefault();
      super.setLayers(layout);
    }
  }

  setDefault() {
    const filteredFeatures = this.features.filter(f => f.matchesMetaForArrayOfConditions(this.getArrayOfConditions()));
    const matchingFeatureExist = super.tryToSetTheSameFeature(filteredFeatures, null, null, true);
    if (!matchingFeatureExist) {
      const hardCodedDefault = filteredFeatures.find((feature) => {
        return feature.dbFeature.displayName && feature.dbFeature.displayName.includes("Tan Hexagon");
      });
      const placeholderDefault = filteredFeatures.find((feature) => {
        return feature.dbFeature.displayName && feature.dbFeature.displayName.includesCI("placeholder");
      });

      this.activeFeature = hardCodedDefault || filteredFeatures[0];
      this.activeFeatureParts = this.setActiveFeatureParts();
      this.placeholderFeature = placeholderDefault || null;
    } else {
      this.activeFeatureParts = this.setActiveFeatureParts();
    }
    this.setShadowFeature();
  }

  getArrayOfConditions() {
    const showerParent = this.getParent();
    const activeShowerPartId = showerParent.showerTubComboIsActive() ? ShowerTubCombo.id : Shower.id;
    const showerSize = showerParent.layout.parts[activeShowerPartId].showerSize();
    return [{
      propName: 'ShowerSize',
      propValue: showerSize
    }];
  }

  setZIndex(zIndexes) {
    const zIndex = zIndexes.Shower.Custom60in.Wall;
    const zIndex2 = zIndexes.Shower.Custom60in.Wall2;
    const zIndex3 = zIndexes.Shower.Custom60in.WallShadow;
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndex;
    }
    if (zIndexes && this.placeholderFeature) {
      this.placeholderFeature.layer.zIndex = zIndex;
    }
    if (zIndexes && this.activeFeatureParts.length) {
      this.activeFeatureParts.forEach((activeFeaturePart) => {
        if (activeFeaturePart && activeFeaturePart.layer) {
          activeFeaturePart.layer.zIndex = zIndex2
        }
      })
    }
    if(zIndexes && this.shadowFeature) {
      this.shadowFeature.layer.zIndex = zIndex3;
    }
  }

  setActiveFeatureParts(fromFeature = this.activeFeature) {
    if (!fromFeature) {
      return []
    }
    const showerSize = fromFeature.metaData["ShowerSize"];
    const name1 = fromFeature.getSplittedFeatureName().split("30in ")[0].split("60in ")[0];
    const activeFeaturePart = fromFeature && fromFeature.partNumber && showerSize ? this.featuresParts.find((feature) => {
      const showerSize2 = feature.metaData["ShowerSize"];
      const name2 = feature.getSplittedFeatureName().split("30in ")[0].split("60in ")[0];
      return showerSize2 && isEqual(showerSize, showerSize2) && (feature.partName === fromFeature.partName || name1 === name2)
    }) : null;
    if (activeFeaturePart) {
      activeFeaturePart.disabled = this.disabled
      return [activeFeaturePart]
    }
    return []
  }
}
